package kz.dentalcrm.app.screens.employees.add

import androidx.compose.animation.animateContentSize
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.ime
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import compose.icons.FeatherIcons
import compose.icons.feathericons.Briefcase
import compose.icons.feathericons.Calendar
import compose.icons.feathericons.ChevronLeft
import compose.icons.feathericons.Lock
import compose.icons.feathericons.Mail
import compose.icons.feathericons.Package
import compose.icons.feathericons.Phone
import compose.icons.feathericons.User
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.access_to_system
import dentalcrm.composeapp.generated.resources.add_employee
import dentalcrm.composeapp.generated.resources.birthday
import dentalcrm.composeapp.generated.resources.choose_gender
import dentalcrm.composeapp.generated.resources.color_label
import dentalcrm.composeapp.generated.resources.email_label
import dentalcrm.composeapp.generated.resources.main_info
import dentalcrm.composeapp.generated.resources.name
import dentalcrm.composeapp.generated.resources.parenthesis
import dentalcrm.composeapp.generated.resources.password_label
import dentalcrm.composeapp.generated.resources.permissions_label
import dentalcrm.composeapp.generated.resources.phone
import dentalcrm.composeapp.generated.resources.positions
import dentalcrm.composeapp.generated.resources.positions_services_info
import dentalcrm.composeapp.generated.resources.save
import dentalcrm.composeapp.generated.resources.services_label
import dentalcrm.composeapp.generated.resources.surname
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.todayIn
import kz.dentalcrm.app.core.ui.UISwitch
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.core.ui.UiStateScaffold
import kz.dentalcrm.app.core.ui.components.BirthDayDialog
import kz.dentalcrm.app.core.ui.components.ChipItem
import kz.dentalcrm.app.core.ui.components.GenderSelectionDialog
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.core.ui.components.UIColorInputClickable
import kz.dentalcrm.app.core.ui.components.UIIconBackButton
import kz.dentalcrm.app.core.ui.components.UISelfDropDownTextInput
import kz.dentalcrm.app.core.ui.components.UISelfTextInput
import kz.dentalcrm.app.core.ui.components.UITextInputClickable
import kz.dentalcrm.app.core.ui.utils.MaskVisualTransformation
import kz.dentalcrm.app.core.utils.formatToISO
import kz.dentalcrm.app.core.utils.getMonths
import kz.dentalcrm.app.core.utils.parseISODate
import kz.dentalcrm.app.screens.employees.add.mvi.AddEmployeeSideEffect
import kz.dentalcrm.app.screens.employees.add.mvi.AddEmployeeState
import kz.dentalcrm.app.screens.employees.add.mvi.AddEmployeeViewEvent
import kz.dentalcrm.app.screens.ui.ContentHeader
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import kz.dentalcrm.app.navigation.AppNavigator
import kz.dentalcrm.app.navigation.AddEmployeeRoute
import org.koin.compose.koinInject
import kotlin.time.ExperimentalTime

@Composable
fun AddEmployeeScreen(
    ) {
    val navigator: AppNavigator = koinInject()
    val viewModel: AddEmployeeViewModel = koinViewModel()
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        val state by viewModel.viewState.collectAsState()

        LaunchedEffect("screen_first") {
            viewModel.setEvent(AddEmployeeViewEvent.LoadInitialData)
        }

        androidx.compose.runtime.DisposableEffect(Unit) {
            onDispose {
                viewModel.setEvent(AddEmployeeViewEvent.ResetState)
            }
        }

        LaunchedEffect("screen_launch") {
            viewModel.effect.onEach { effect ->
                when (effect) {
                    is AddEmployeeSideEffect.SaveSuccess -> {
                        navigator.navigateBackWithResult(
                            key = AddEmployeeRoute.RESULT_KEY,
                            result = AddEmployeeRoute.Result(employeeId = -1)
                        )
                    }

                    is AddEmployeeSideEffect.ShowError -> {
                        // TODO: Show error message to user (e.g., Toast or Snackbar)
                    }
                }
            }.collect()
        }

        UiStateScaffold(
            modifier = Modifier.fillMaxSize()
                .background(color = DefaultTheme.colors.surface),
            isLoading = state.screenState is ScreenState.Loading
        ) {
            Column(
                modifier = Modifier.fillMaxSize()
                    .statusBarsPadding()
            ) {
                ContentHeader(
                    modifier = Modifier.fillMaxWidth()
                        .padding(horizontal = 12.dp),
                    text = stringResource(Res.string.add_employee),
                    leadingContent = {
                        UIIconBackButton(
                            onClick = {
                                navigator.navigateUp()
                            }
                        )
                    }
                )

                if (state.screenState is ScreenState.Idle) {
                    AddEmployeeContent(
                        modifier = Modifier.weight(1f),
                        state = state,
                        onEvent = viewModel::setEvent
                    )
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class, ExperimentalTime::class)
@Composable
fun AddEmployeeContent(
    modifier: Modifier = Modifier,
    state: AddEmployeeState,
    onEvent: (AddEmployeeViewEvent) -> Unit
) {
    var birthdayDialog by remember { mutableStateOf(false) }
    var genderDialog by remember { mutableStateOf(false) }

    if (birthdayDialog) {
        val currentDate = state.birthDate.parseISODate() ?: kotlin.time.Clock.System.todayIn(TimeZone.currentSystemDefault())

        BirthDayDialog(
            defaultTime = currentDate,
            onDismissRequest = { birthdayDialog = false },
            onDateSelected = { date ->
                val formattedDate = date.formatToISO()
                onEvent(AddEmployeeViewEvent.UpdateBirthDate(formattedDate))
            }
        )
    }

    if (genderDialog) {
        GenderSelectionDialog(
            onDismissRequest = { genderDialog = false },
            onGenderSelected = { gender ->
                onEvent(AddEmployeeViewEvent.UpdateGender(gender))
            }
        )
    }

    val bottomPadding = WindowInsets.ime.asPaddingValues().calculateBottomPadding()

    LazyColumn(
        modifier = modifier.fillMaxSize()
            .padding(horizontal = 16.dp)
            .animateContentSize(),
        state = rememberLazyListState(),
        contentPadding = PaddingValues(bottom = bottomPadding + 200.dp)
    ) {
        item {
            Spacer(modifier = Modifier.height(16.dp))
        }

        // Main Info Section
        item {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .heightIn(min = 44.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceAlternative,
                        shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
                    ),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 8.dp),
                    text = stringResource(Res.string.main_info),
                    color = DefaultTheme.colors.onSurface,
                    style = DefaultTheme.typography.bodyLargeMedium,
                )
            }

            InputItem(
                label = stringResource(Res.string.name),
                textError = state.nameError,
                value = state.name
            ) {
                onEvent(AddEmployeeViewEvent.UpdateName(it))
            }

            InputItem(
                label = stringResource(Res.string.surname),
                textError = state.surnameError,
                value = state.surname
            ) {
                onEvent(AddEmployeeViewEvent.UpdateSurname(it))
            }

            InputItem(
                label = stringResource(Res.string.parenthesis),
                value = state.patronymic.orEmpty()
            ) {
                onEvent(AddEmployeeViewEvent.UpdatePatronymic(it))
            }

            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceAlternative)
                    .padding(horizontal = 16.dp, vertical = 4.dp)
                    .padding(bottom = 4.dp)
            ) {
                UITextInputClickable(
                    modifier = Modifier.fillMaxWidth(),
                    leadingIcon = FeatherIcons.User,
                    defaultValue = state.gender,
                    label = stringResource(Res.string.choose_gender),
                    valueChanged = { },
                    onClicked = {
                        genderDialog = true
                    }
                )
            }

            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceAlternative)
                    .padding(horizontal = 16.dp, vertical = 4.dp)
            ) {
                val displayDate = state.birthDate.parseISODate()?.let { date ->
                    val monthNames = getMonths()
                    "${
                        date.day.toString().padStart(2, '0')
                    } ${monthNames[date.month.number - 1]} ${date.year}"
                } ?: ""

                UITextInputClickable(
                    modifier = Modifier.fillMaxWidth(),
                    leadingIcon = FeatherIcons.Calendar,
                    isOnlyNumbers = false,
                    defaultValue = displayDate,
                    label = stringResource(Res.string.birthday),
                    valueChanged = { },
                    onClicked = {
                        birthdayDialog = true
                    }
                )
            }

            PhoneInputItem(
                label = stringResource(Res.string.phone),
                textError = state.phoneError,
                value = state.phone
            ) { value ->
                onEvent(AddEmployeeViewEvent.UpdatePhone(value))
            }
            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceAlternative)
                    .padding(horizontal = 16.dp, vertical = 4.dp)
            ) {
                UIColorInputClickable(
                    modifier = Modifier.fillMaxWidth(),
                    label = stringResource(Res.string.color_label),
                    defaultValue = state.color,
                    valueChanged = {},
                    colorChanged = { onEvent(AddEmployeeViewEvent.UpdateColor(it)) }
                )
            }

            Box(
                modifier = Modifier.fillMaxWidth()
                    .height(20.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceAlternative,
                        shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp)
                    )
            )
        }

        item {
            Spacer(modifier = Modifier.height(24.dp))
        }

        // Positions and Services Section
        item {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .heightIn(min = 44.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceAlternative,
                        shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
                    ),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 8.dp),
                    color = DefaultTheme.colors.onSurface,
                    text = stringResource(Res.string.positions_services_info),
                    style = DefaultTheme.typography.bodyLargeMedium,
                )
            }

            // Positions Dropdown
            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceAlternative)
                    .padding(horizontal = 16.dp, vertical = 8.dp)
            ) {
                Column {
                    UISelfDropDownTextInput(
                        modifier = Modifier.fillMaxWidth(),
                        leadingIcon = FeatherIcons.Briefcase,
                        label = stringResource(Res.string.positions),
                        value = "",
                        items = state.availablePositions,
                        selectedItems = state.selectedPositions,
                        itemToString = { it.name ?: "" },
                        multiSelect = true,
                        onItemsSelected = { positions ->
                            onEvent(AddEmployeeViewEvent.UpdatePositions(positions))
                        }
                    )

                    // Show selected positions as chips
                    if (state.selectedPositions.isNotEmpty()) {
                        Spacer(modifier = Modifier.height(8.dp))
                        FlowRow(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(8.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp),
                            maxItemsInEachRow = 4,
                            maxLines = 6
                        ) {
                            val itemsToShow = if (state.selectedPositions.size > 5) {
                                state.selectedPositions.take(5)
                            } else {
                                state.selectedPositions
                            }

                            itemsToShow.forEach { position ->
                                ChipItem(
                                    text = position.name ?: "",
                                    onRemove = {
                                        onEvent(
                                            AddEmployeeViewEvent.UpdatePositions(
                                                state.selectedPositions - position
                                            )
                                        )
                                    }
                                )
                            }

                            if (state.selectedPositions.size > 5) {
                                Text(
                                    text = "+${state.selectedPositions.size - 5} more",
                                    style = DefaultTheme.typography.bodySmallMedium,
                                    color = DefaultTheme.colors.onSurfaceVariant,
                                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 6.dp)
                                )
                            }
                        }
                    }
                }
            }

            // Services Dropdown
            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceAlternative)
                    .padding(horizontal = 16.dp, vertical = 8.dp)
            ) {
                Column {
                    UISelfDropDownTextInput(
                        modifier = Modifier.fillMaxWidth(),
                        leadingIcon = FeatherIcons.Package,
                        label = stringResource(Res.string.services_label),
                        value = "",
                        items = state.availableServices,
                        selectedItems = state.selectedServices,
                        itemToString = { it.name ?: "" },
                        multiSelect = true,
                        onItemsSelected = { services ->
                            onEvent(AddEmployeeViewEvent.UpdateServices(services))
                        }
                    )

                    // Show selected services as chips
                    if (state.selectedServices.isNotEmpty()) {
                        Spacer(modifier = Modifier.height(8.dp))
                        FlowRow(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(4.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp),
                            maxItemsInEachRow = 4,
                            maxLines = 6
                        ) {
                            val itemsToShow = if (state.selectedServices.size > 5) {
                                state.selectedServices.take(5)
                            } else {
                                state.selectedServices
                            }

                            itemsToShow.forEach { service ->
                                ChipItem(
                                    text = service.name ?: "",
                                    onRemove = {
                                        onEvent(
                                            AddEmployeeViewEvent.UpdateServices(
                                                state.selectedServices - service
                                            )
                                        )
                                    }
                                )
                            }

                            if (state.selectedServices.size > 5) {
                                Text(
                                    text = "+${state.selectedServices.size - 5} more",
                                    style = DefaultTheme.typography.bodySmallMedium,
                                    color = DefaultTheme.colors.onSurfaceVariant,
                                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 6.dp)
                                )
                            }
                        }
                    }
                }
            }
        }
        item {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .heightIn(min = 44.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceAlternative,
                    )
                    .clickable {
                        onEvent(AddEmployeeViewEvent.UpdateCreateAccount(!state.createAccount))
                    }
                    .padding(horizontal = 8.dp, vertical = 8.dp),
                contentAlignment = Alignment.CenterStart
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    androidx.compose.material3.Checkbox(
                        checked = state.createAccount,
                        onCheckedChange = { onEvent(AddEmployeeViewEvent.UpdateCreateAccount(it)) },
                        colors = androidx.compose.material3.CheckboxDefaults.colors(
                            checkedColor = DefaultTheme.colors.primary,
                            uncheckedColor = DefaultTheme.colors.outline
                        )
                    )
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        text = stringResource(Res.string.access_to_system),
                        style = DefaultTheme.typography.bodyMediumMedium,
                        color = DefaultTheme.colors.onSurface
                    )
                }
            }

        }
        if (state.createAccount) {
            item {
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .background(color = DefaultTheme.colors.surfaceAlternative)
                        .animateItem()
                ) {
                    Spacer(modifier = Modifier.height(8.dp))
                    // Email Input
                    Box(
                        modifier = Modifier.fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp)
                    ) {
                        UISelfTextInput(
                            modifier = Modifier.fillMaxWidth(),
                            leadingIcon = FeatherIcons.Mail,
                            value = state.email,
                            label = stringResource(Res.string.email_label),
                            keyboardOptions = KeyboardOptions(
                                imeAction = ImeAction.Next,
                                keyboardType = KeyboardType.Email
                            ),
                            errorText = state.emailError,
                            isOnError = state.emailError.isNotEmpty(),
                            valueChanged = { onEvent(AddEmployeeViewEvent.UpdateEmail(it)) }
                        )
                    }
                    // Password Input
                    Box(
                        modifier = Modifier.fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp)
                    ) {
                        UISelfTextInput(
                            modifier = Modifier.fillMaxWidth(),
                            leadingIcon = FeatherIcons.Lock,
                            value = state.password,
                            label = stringResource(Res.string.password_label),
                            keyboardOptions = KeyboardOptions(
                                imeAction = ImeAction.Done,
                                keyboardType = KeyboardType.Password
                            ),
                            errorText = state.passwordError,
                            isOnError = state.passwordError.isNotEmpty(),
                            valueChanged = { onEvent(AddEmployeeViewEvent.UpdatePassword(it)) }
                        )
                    }
                    // Permissions Header
                    Box(
                        modifier = Modifier.fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 12.dp)
                    ) {
                        Text(
                            text = stringResource(Res.string.permissions_label),
                            style = DefaultTheme.typography.bodyMediumMedium,
                            color = DefaultTheme.colors.onSurface
                        )
                    }

                    state.availablePermissions.forEach { permission ->
                        Box(
                            modifier = Modifier.fillMaxWidth()
                                .clickable {
                                    onEvent(AddEmployeeViewEvent.TogglePermission(permission))
                                }
                                .padding(horizontal = 16.dp, vertical = 12.dp)
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    text = permission.alias ?: permission.name ?: "",
                                    style = DefaultTheme.typography.bodyMediumRegular,
                                    color = DefaultTheme.colors.onSurface
                                )
                                UISwitch(
                                    modifier = Modifier.width(40.dp).height(24.dp),
                                    checked = state.selectedPermissions.contains(permission),
                                    onCheckedChange = {
                                        onEvent(
                                            AddEmployeeViewEvent.TogglePermission(
                                                permission
                                            )
                                        )
                                    },
                                    enabled = true
                                )
                            }
                        }
                    }
                    Box(
                        modifier = Modifier.fillMaxWidth()
                            .height(16.dp)
                            .background(
                                color = DefaultTheme.colors.surfaceAlternative,
                                shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp)
                            )
                    )
                }
            }
        }
        // Save Button
        item {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceAlternative)
                    .padding(horizontal = 16.dp)
                    .padding(top = 24.dp)
            ) {
                UIButton(
                    modifier = Modifier.fillMaxWidth(),
                    text = stringResource(Res.string.save),
                    onClick = {
                        onEvent(AddEmployeeViewEvent.SaveEmployee)
                    }
                )
            }

            Box(
                modifier = Modifier.fillMaxWidth()
                    .height(16.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceAlternative,
                        shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp)
                    )
            )
        }
        item {
            Spacer(
                modifier = Modifier.height(56.dp)
                    .navigationBarsPadding()
            )
        }
    }
}

@Composable
fun InputItem(
    textError: String = "",
    icon: ImageVector = FeatherIcons.User,
    isImeDone: Boolean = false,
    value: String = "",
    label: String = "",
    onValueChange: (String) -> Unit,
) {
    Box(
        modifier = Modifier.fillMaxWidth()
            .background(color = DefaultTheme.colors.surfaceAlternative)
    ) {
        UISelfTextInput(
            modifier = Modifier
                .padding(horizontal = 16.dp, vertical = 8.dp)
                .fillMaxWidth(),
            leadingIcon = icon,
            value = value,
            label = label,
            keyboardOptions = KeyboardOptions(imeAction = if (isImeDone) ImeAction.Done else ImeAction.Next).copy(
                keyboardType = KeyboardType.Text
            ),
            errorText = textError,
            isOnError = textError.isNotEmpty(),
            valueChanged = onValueChange
        )
    }
}

@Composable
fun PhoneInputItem(
    textError: String = "",
    value: String = "",
    label: String = "",
    onValueChange: (String) -> Unit,
) {
    Box(
        modifier = Modifier.fillMaxWidth()
            .background(color = DefaultTheme.colors.surfaceAlternative)
    ) {
        UISelfTextInput(
            modifier = Modifier
                .padding(horizontal = 16.dp, vertical = 8.dp)
                .fillMaxWidth(),
            leadingIcon = FeatherIcons.Phone,
            maxLength = 10,
            isOnlyNumbers = true,
            keyboardType = KeyboardType.Phone,
            visualTransformation = MaskVisualTransformation("+7 ###-###-####"),
            value = value,
            label = label,
            errorText = textError,
            isOnError = textError.isNotEmpty(),
            valueChanged = onValueChange
        )
    }
}
